import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";

import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import Pencil from "../../components/svg/pencil";
import Tableloader from "../../components/table-loader";
import { Form, Formik } from "formik";
import { Accordion } from "react-bootstrap";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { getFaqQuery, handleEditClick, handleWorkDelete, handleAddBlogClick, initialValues, handleSubmit } = useBlogsProvider();

  if (getFaqQuery?.isPending) {
    return <Tableloader />;
  }

  return (
    <Section>
      <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="1">
                <Accordion.Header>SEO Meta</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                    <div className="flex flex-col ">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Banner</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_heading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="SubHeading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_heading" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 mt-3">
                    <div className="flex flex-col">
                      <Label label="CTA" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_cta.label" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_cta.redirect_link" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="CTA" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_cta.label" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_cta.redirect_link" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 mt-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikTextarea name="header.description" rootClassName="w-full" as="textarea" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>FAQ's</Accordion.Header>
                <Accordion.Body>
                  <div className="flex items-center justify-between gap-4">
                    <div className="bg-[black] p-1 rounded-full w-auto cursor-pointer ml-auto" onClick={handleAddBlogClick}>
                      <Plus className="text-[white]" />
                    </div>
                  </div>

                  <div className="mt-3 overflow-x-auto mb-10">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">Question</th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">Answer</th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-center w-[70px]">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getFaqQuery?.data?.data?.data?.map((item, index) => (
                          <tr key={index}>
                            <td className="border border-gray-300 px-4 py-3 align-middle">
                              <Label className="mb-0 text-black text-[15px]" label={item.ques} />
                            </td>
                            <td className="border border-gray-300 px-4 py-3 align-middle">
                              <Label className="mb-0 text-black text-[15px]" label={item.ans} />
                            </td>
                            <td className="border border-gray-300 px-4 py-3 align-middle text-center">
                              <div className="flex items-center justify-center gap-3">
                                <Pencil className="cursor-pointer" onClick={() => handleEditClick(item)} />
                                <Trash className="cursor-pointer" onClick={() => handleWorkDelete(item)} />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
